import 'assets/styles/keenpages/login-1.css';
import ActivateAccountResultForm from 'features/Account/components/ActivateAccountResultForm';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

function ActivateAccountScreen(props) {
    // MARK: --- Params ---
    const [searchParams] = useSearchParams();
    const result = searchParams.get('result');
    const path = window.location.pathname;
    const isMaintainerApp = useMemo(() => {
        return path?.includes(AppRoute.maintainerApp);
    }, [path])

    const isSuccess = useMemo(() => {
        return result === 'success';
    }, [result])

    // MARK: --- Functions ---

    return (
        <div className="d-flex flex-column flex-root overflow-hidden">
            <div className="bg-white d-flex flex-column flex-column-fluid flex-lg-row login login-1 login-signin-on min-vh-100">
                {/* aside */}
                <div
                    className="login-aside d-flex flex-column"
                    style={{
                        backgroundColor: isMaintainerApp ? '#1EA559' : '',
                        backgroundImage: `url(${isSuccess
                            ? !isMaintainerApp
                                ? AppResource.images.tmt.bgActivateAccountSuccess
                                : ''
                            : !isMaintainerApp
                                ? AppResource.images.tmt.bgActivateAccountFailed
                                : AppResource.images.tmt.bgActivateMaintainerAccountFailedBg})`,
                        backgroundSize: 'cover',
                    }}
                >
                    {/* aside top */}
                    <div className="d-flex flex-column h-100 justify-content-end" style={{ paddingBottom: '60px' }}>
                        <div className="d-flex align-items-end justify-content-center mb-5 position-relative">
                            <a href="#">
                                <img
                                    alt="logo"
                                    src={AppResource.icons.tmt.tmtLogoActivateAccount}
                                    className="h-100px"
                                />
                            </a>
                        </div>
                        <div
                            className={`aside-img d-flex w-100 bgi-no-repeat bgi-position-y-bottom bgi-position-x-center ${!isMaintainerApp ? 'mb-lg-8' : ''}`}
                            style={{
                                backgroundImage: `url(${isSuccess
                                    ? !isMaintainerApp
                                        ? AppResource.images.tmt.activateAccountSuccessImg
                                        : AppResource.images.tmt.maintainerActivateSuccessBg
                                    : !isMaintainerApp
                                        ? AppResource.images.tmt.activateAccountFailedImg
                                        : AppResource.images.tmt.maintainerActivateFailedBg})`,
                                backgroundSize: 'contain',
                                height: '300px',
                            }}
                        ></div>
                    </div>
                </div>

                {/* content */}
                <div className="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-auto p-7 mx-auto">
                    {/* content body */}
                    <div className="d-flex flex-column-fluid flex-center">
                        <ActivateAccountResultForm isSuccess={isSuccess} />
                    </div>
                </div>
            </div>
        </div >
    );
}

export default ActivateAccountScreen;
